import React, { Component } from 'react';
import {
    WithStyles, createStyles
} from '@material-ui/core';
import { Theme } from '@material-ui/core/styles/createMuiTheme';
import { connect } from 'react-redux';
import { bindActionCreators } from 'redux';
import { withStyles } from '@material-ui/core/styles';
import _ from 'lodash';
import VideoProgressBar from './VideoProgressBar';
import VideoUploadDialog from './VideoUploadDialog';
import VideoUrlUploadDialog from './VideoUrlUploadDialog';
import { MyPATDialog } from '../../../../common';
import contentService from '../../../services/contentService';
import videoUploadService from '../../../services/videoUploadService';
import { videoActions } from '../../../reducers/videoCreateContentReducers';
import { showMsg } from '../../../../course/actions/loaderAlert';
import axios from "axios";
import { getKeyFromStreamUrl } from '../../../../../utils';
import { VIDEO_UPLOAD_MODES } from '../../../../../constants/comman';
import * as JSLZString from 'lz-string';

const styles = (theme: Theme) => createStyles({
});

interface StudyVideoCreateProps extends WithStyles<typeof styles> {
    dialogOpen: boolean;
    onDialogClose: Function;
    videoUploadModal: boolean;
    isVideoUrlUploadModal: boolean;
    changeVideoUploadProgressPercentage: Function;
    addVideoDetails: Function;
    handleURL: Function;
    showMsg: Function;
    openVideoModal: Function;
    resetVideoModalState: Function;
    mode: string;
    submitVideo: Function;
    videoId?: any;
}

interface StudyVideoCreateState {
}
class StudyVideoCreate extends Component<StudyVideoCreateProps, StudyVideoCreateState> {
    constructor(props: StudyVideoCreateProps) {
        super(props);
        this.state = {
        }
    }
    uploadVideo = (file: any = {}) => {
        const source = axios.CancelToken.source();
        const { changeVideoUploadProgressPercentage, addVideoDetails, handleURL, showMsg, openVideoModal, videoId } = this.props;
        if (file.length > 524288000) {
            showMsg('Please upload a video of size less than 500 MB', 'error');
            return;
        } else if(!file.type.includes('video')) {
            showMsg('Only .mp4 files are supported', 'error');
            return;
        }
        openVideoModal();
        addVideoDetails({
            file: file,
            name: file.name || '',
            length: file.size || 0,
            type: file.type || '',
            source
        });
        changeVideoUploadProgressPercentage(0);

        //upload and hange state
        videoUploadService.uploadVideo(file, (event: any) => {
            changeVideoUploadProgressPercentage(Math.round((100 * event.loaded) / event.total));
        }, source.token, videoId)
            .then((response) => {
                handleURL(response);
            })
            .catch((err: any) => {
                if (axios.isCancel(err)) {
                    showMsg('Video upload cancelled', 'error');
                  }
                this.props.resetVideoModalState();
            })
    }

    getThumbnailURL = (key: any) => {
        return videoUploadService.uploadThumbnail(key, 10).then((response) => {
            return response
        }).catch(() => {
            return ''
        });

    }

    createVideoContent = async (videoUrl: string) => {
        videoUrl = JSLZString.decompressFromEncodedURIComponent(videoUrl) || '';
        const videoKey = getKeyFromStreamUrl(videoUrl);
        const thumbnail = await this.getThumbnailURL(videoKey) || '';
        const thumbnailUrl = await videoUploadService.uploadThumbnailUrl(thumbnail);
    let saveRequest:any = {
        videoUrl: videoKey,
        completionPercent: 25,
        thumbnailUrl
    }
        contentService.save('', 'videos', saveRequest, false).then((result: any) => {
            const {
                responseObject: {
                    video: { _id } = {}
                }
            }: {
                responseObject: {
                    video: {
                        _id?: string
                    }
                }
            } = result;
            if (_id) {
                this.props.onDialogClose()
                window.open(`/content/edit/studymaterial/videos/${_id}videos`, '_blank')
            }
        })
    }

    deleteVideo = (videoUrl: any) => {
        const videoKey: string = getKeyFromStreamUrl(videoUrl);
        videoUploadService.deleteVideoService({videoKey}).then(async (resData: any) => {
            if (resData.statusCode === 200) {
                this.props.resetVideoModalState();
                }else{
                    this.props.showMsg('Unable to delete Video', 'error');
                }
    }).catch(() => {
        this.props.showMsg('Unable to delete Video', 'error');
    });
    }

    render() {
        const { dialogOpen, onDialogClose, videoUploadModal, isVideoUrlUploadModal, mode, submitVideo, videoId } = this.props;
        const otherDialogProps = {
            fullWidth: true,
            maxWidth: 'sm',
            scroll: 'body',
        };
        return (
            <>
                { mode !== VIDEO_UPLOAD_MODES.EDIT ? <MyPATDialog
                    dialogHeading="Insert Video"
                    dialogOpen={dialogOpen}
                    dialogHasActions={false}
                    customButtonVariant="withoutBorderCloseIcon"
                    onDialogClose={onDialogClose}
                    isAlignCenter={true}
                    otherDialogProps={otherDialogProps}
                >
                    {
                        videoUploadModal ? <VideoProgressBar onDialogClose={onDialogClose} createVideoContent={this.createVideoContent} deleteVideo={this.deleteVideo}/> : (
                            isVideoUrlUploadModal ? <VideoUrlUploadDialog onDialogClose={onDialogClose} createVideoContent={this.createVideoContent} deleteVideo={this.deleteVideo}/>
                                : <VideoUploadDialog onDialogClose={onDialogClose} uploadVideo={this.uploadVideo} />
                        )
                    }
                </MyPATDialog>
                :    videoUploadModal ? <VideoProgressBar mode={VIDEO_UPLOAD_MODES.EDIT} onDialogClose={onDialogClose} createVideoContent={submitVideo} deleteVideo={this.deleteVideo}/> : (
                        isVideoUrlUploadModal ? <VideoUrlUploadDialog mode={VIDEO_UPLOAD_MODES.EDIT} onDialogClose={onDialogClose} createVideoContent={submitVideo} videoId={videoId} deleteVideo={this.deleteVideo} />
                            : <VideoUploadDialog mode={VIDEO_UPLOAD_MODES.EDIT} onDialogClose={onDialogClose} uploadVideo={this.uploadVideo} />
                    )
                }

            </>
        )
    }
}

const mapStateToProps = (state: any) => {
    return {
        videoUploadModal: _.get(state, 'videoCreateContent.videoUploadModal', false),
        isVideoUrlUploadModal: state.videoCreateContent.isVideoUrlUploadModal
    }
};

const mapDispatchToProps = (dispatch: any) => bindActionCreators({
    handleURL: videoActions.videoUrlChanged,
    changeVideoUploadProgressPercentage: videoActions.changeVideoUploadProgressPercentage,
    addVideoDetails: videoActions.addVideoDetails,
    showMsg: showMsg,
    openVideoModal: videoActions.openVideoModal,
    resetVideoModalState: videoActions.resetVideoModalState
}, dispatch);
// @ts-ignore
export default connect(mapStateToProps, mapDispatchToProps)(withStyles(styles)(StudyVideoCreate));